import React, { useContext, useEffect, useRef, useState } from 'react'
import MonsterWindow from './subComponents/MonsterWindow/MonsterWindow'

import Cards from '../Cards/Cards.jsx'

import { CharacterContext } from '../../contexts/character'
import { SubStatsContext } from '../../contexts/subStats'
import { Player, Monster, defaultValue } from '../../constants/entity'
import { getBattleDamage } from '../../constants/battleFormulas'
import * as Calc from '../../constants/formulas'
// import skillInfoList from '../../data/skillInfo.json'

import { Item } from '../../contexts/databases'
import { getSkillRatio } from '../../constants/skillMod'
import { isSkillMagic } from '../../constants/battleOptions'
import SizePenalty from '../../constants/sizePenalty.json'
import SkillOption from '../../data/skill_db.json'
import SkillActivePassive from '../../data/skillActivePassive.json'
import * as jobID from '../../data/jobID.js'
import elementTable from '../../constants/elementTable.json'

import Select from 'react-select'

//css
import './battleTab.scss'

function BattleTab(props) {
	let { bonuses, inventory, skills, job, setBuffs, refreshPlayer } =
		useContext(CharacterContext)
	let { maxHP, maxSP, Def, softDef, Mdef, softMdef, hit, flee } =
		useContext(SubStatsContext)
	const [options, setOptions] = useState([])
	const [optionsSkillLv, setOptionsoptionsSkillLv] = useState([])
	const [currentSkill, setCurrentSkill] = useState('NV_BASIC')
	const [currentSkillLv, setCurrentSkillLv] = useState(Number(1))
	const [monster, setMonster] = useState(new Monster())
	const [currentPlayer, setCurrentPlayer] = useState()
	const [baseDamage, setBaseDamage] = useState([0, 0, 0])
	const [baseMagicDamage, setBaseMagicDamage] = useState([0, 0, 0])
	const [skillDamages, setSkillDamages] = useState([0, 0, 0])
	const [skillOption, setSkillOption] = useState(0)
	const skillRef = useRef()
	const skillLvRef = useRef()

	const tempLabel = ['Min', 'Ave', 'Max']
	let partyBuffList_AB = getSkillList('BuffParty', jobID.ARCH_BISHOP_T)
	let partyBuffList_MIWA = getSkillList('BuffParty', jobID.WANDERER_T)
	partyBuffList_MIWA.push(...getSkillList('BuffParty', jobID.MINSTREL_T))
	partyBuffList_MIWA = [...new Set(partyBuffList_MIWA)]

	const size = '25px'
	const customStyles = {
		control: (provided, state) => ({
			...provided,
			background: '#fff',
			borderColor: '#9e9e9e',
			minHeight: size,
			height: size,
			boxShadow: state.isFocused ? null : null,
		}),
		valueContainer: (provided, state) => ({
			...provided,
			height: size,
			padding: '0 6px',
		}),
		input: (provided, state) => ({
			...provided,
			margin: '0px',
		}),
		indicatorSeparator: (state) => ({
			display: 'none',
		}),
		indicatorsContainer: (provided, state) => ({
			...provided,
			height: size,
		}),
	}

	const getElementalMultiplier = () => {
		let attackElement = 'Ele_Neutral'
		let searchedSkill = currentSkill
		let thisSkill = SkillOption.find(
			(skill) => skill.Name === searchedSkill,
		)
		let monsterElementLevel = monster?.ElementLevel
			? monster.ElementLevel
			: 1
		let monsterElement = monster?.Element
			? 'Ele_' + monster.Element
			: 'Ele_Neutral'
		//Because some monsters have Dark element and in element table it's named Shadow
		if (monsterElement === 'Ele_Dark') monsterElement = 'Ele_Shadow'
		if (thisSkill?.Element === 'Weapon' && bonuses?.bAtkEle)
			attackElement = bonuses.bAtkEle
		else if (thisSkill?.Element !== 'Weapon' && thisSkill?.Element)
			attackElement = 'Ele_' + thisSkill.Element
		return elementTable[monsterElementLevel][monsterElement][attackElement]
	}

	useEffect(() => {
		if (currentPlayer && monster) {
			let ATKMultipliers = {
				ATKMultiplier: defaultValue(
					currentPlayer?.Bonuses?.bAtkRate,
					0,
				),
				RaceMultiplier:
					defaultValue(currentPlayer?.Bonuses?.bAddRace?.RC_All, 0) +
					defaultValue(
						currentPlayer?.Bonuses?.bAddRace?.[
							'RC_' +
								(monster?.Race === 'Demihuman'
									? 'DemiHuman'
									: monster?.Race)
						],
						0,
					),
				SizeMultiplier:
					defaultValue(
						currentPlayer?.Bonuses?.bAddSize?.Size_All,
						0,
					) +
					defaultValue(
						currentPlayer?.Bonuses?.bAddSize?.[
							'Size_' + monster?.Size
						],
						0,
					),
				TargetPropertyMultiplier:
					defaultValue(currentPlayer?.Bonuses?.bAddEle?.Ele_All, 0) +
					defaultValue(
						currentPlayer?.Bonuses?.bAddEle?.[
							'Ele_' + monster?.Element
						],
						0,
					),
				// TODO, will not work as it is
				MonsterMultiplier:
					defaultValue(
						currentPlayer?.Bonuses?.bAddRace2?.Class_All,
						0,
					) +
					defaultValue(
						currentPlayer?.Bonuses?.bAddRace2?.[
							'Ele_' + monster?.Element
						],
						0,
					),
				ClassMultiplier:
					defaultValue(
						currentPlayer?.Bonuses?.bAddClass?.Class_All,
						0,
					) +
					defaultValue(
						currentPlayer?.Bonuses?.bAddClass?.[
							monster?.Class
								? 'Class_' + monster?.Class
								: 'Class_Normal'
						],
						0,
					),
				PropertyMultiplier: 0, // ???
				EDPMultiplier: 1,
			}
			setBaseDamage(
				Calc.getBaseDamage(
					defaultValue(
						currentPlayer?.Inventory['Right_Hand'],
						new Item('Right_Hand', true),
					),
					defaultValue(currentPlayer?.baseLevel, 1),
					defaultValue(currentPlayer?.Str, 1),
					defaultValue(currentPlayer?.Dex, 1),
					defaultValue(currentPlayer?.Luk, 1),
					defaultValue(currentPlayer?.Bonuses?.bBaseAtk, 0) +
						defaultValue(currentPlayer?.Bonuses?.bAtk, 0) +
						defaultValue(
							currentPlayer?.Inventory['Ammo']?.Attack,
							0,
						),
					//defaultValue(currentPlayer?.Bonuses['bMastery'], 0),
					defaultValue(
						SizePenalty.find(
							(weapType) =>
								weapType.Weapon ===
								currentPlayer.Inventory.Right_Hand.SubType,
						)[defaultValue(monster?.Size, 'Small')],
						100,
					),
					ATKMultipliers,
					getElementalMultiplier(),
				),
			)
			setBaseMagicDamage(
				Calc.getBaseMagicDamage(
					defaultValue(
						currentPlayer?.Inventory['Right_Hand'],
						new Item('Right_Hand', true),
					),
					defaultValue(currentPlayer?.baseLevel, 1),
					defaultValue(currentPlayer?.Int, 1),
					defaultValue(currentPlayer?.Dex, 1),
					defaultValue(currentPlayer?.Luk, 1),
					defaultValue(currentPlayer?.Bonuses?.bMatk, 0),
					getElementalMultiplier(),
				),
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPlayer, monster, skillOption])
	useEffect(() => {
		let newMonster = new Monster(0)
		setMonster(newMonster)
		let newBuffs = []
		initBuffs(partyBuffList_AB, newBuffs)
		initBuffs(partyBuffList_MIWA, newBuffs)

		setBuffs(newBuffs)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	useEffect(() => {
		// console.log('player', player)
		let newPlayer = convertPlayerToEntity(
			refreshPlayer(),
			{
				MaxHP: maxHP,
				MaxSP: maxSP,
				DEF: Def,
				SoftDEF: softDef,
				MDEF: Mdef,
				SoftMDEF: softMdef,
				Hit: hit,
				Flee: flee,
			},
			skills,
			bonuses,
		)
		setCurrentPlayer(newPlayer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		// player,
		skills,
		bonuses,
		flee,
		hit,
		inventory,
		maxHP,
		maxSP,
		softDef,
		softMdef,
	])

	//skill list option
	useEffect(() => {
		let newOptions = []
		//get Active skill list from skillActivePassive.json
		let skillList = getSkillList('Active', job)

		//add auto attack
		newOptions.push({
			value: '0',
			label: 'Auto Attack',
			key: 'skill_none',
		})
		skills
			.filter((skill) => skillList.includes(skill.AegisName))
			.forEach((skill) => {
				newOptions.push({
					value: skill.AegisName,
					label: skill.SkillName,
					key: 'skill_' + skill.AegisName,
				})
			})
		setOptions(newOptions)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [skills])
	//skill lv option
	useEffect(() => {
		let newOptions = []
		let maxSkillLv = skills.find(
			(skill) => skill.AegisName === currentSkill,
		)?.MaxLevel
		maxSkillLv = maxSkillLv ? maxSkillLv : 1
		for (let i = 1; i <= maxSkillLv; i++) {
			newOptions.push({
				value: i,
				label: i,
				key: 'skLv' + i,
			})
		}
		setSkillOption(SkillOption.find((skill) => skill.Name === currentSkill))

		setOptionsoptionsSkillLv(newOptions)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentSkill])
	useEffect(() => {
		let selectedSkill = SkillOption.find(
			(skill) => skill.Name === currentSkill,
		)
		if (typeof selectedSkill?.HitCount === 'number') {
			setSkillOption(selectedSkill.HitCount)
		} else if (typeof selectedSkill?.HitCount === 'object') {
			setSkillOption(
				selectedSkill.HitCount.find(
					(skill) => skill.Level === currentSkillLv,
				).Count,
			)
		} else setSkillOption(Number(1))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [skillOption, currentSkillLv])

	const createMonster = (mob) => {
		let newMonster = new Monster(mob)
		setMonster(newMonster)
	}

	useEffect(() => {
		setSkillDamages(
			isSkillMagic(currentSkill)
				? baseMagicDamage.map((damage) =>
						getBattleDamage(
							damage,
							currentPlayer,
							monster,
							currentSkill,
							currentSkillLv,
						),
					)
				: baseDamage.map((damage) =>
						getBattleDamage(
							damage,
							currentPlayer,
							monster,
							currentSkill,
							currentSkillLv,
						),
					),
		)
	}, [
		baseDamage,
		baseMagicDamage,
		currentSkill,
		currentSkillLv,
		monster,
		currentPlayer,
	])
	//Reset Skill select on job change
	useEffect(() => {
		if (options.length > 0) skillRef.current?.selectOption(options[0])
	}, [options])
	//Reset Skill level select on Skill change
	useEffect(() => {
		if (optionsSkillLv.length > 0)
			skillLvRef.current?.selectOption(optionsSkillLv[0])
	}, [optionsSkillLv])

	// function handleBuffChange(event, currentbuff) {
	// 	let newbuffs = buffs
	// 	let buffIndex = buffs.findIndex((buff) => buff.name === currentbuff)
	// 	//security in case index is not found
	// 	if (~buffIndex) newbuffs[buffIndex].level = Number(event.target.value)
	// 	setBuffs(newbuffs)
	// }
	return (
		// <div className={props.className} style={{ paddingTop: 20 + 'px' }}>
		// <div className={props.className} style={{ paddingRight: 25 + 'px' }}>
		<div className={props.className}>
			{/* // style={{ width: 350 + 20 + 2 + 'px', paddingTop: 20 + 'px' }} //350px wide + 2*10px padding + 2*1px border from MonsterWindow */}
			<div className='BattleWindow'>
				{/* <Cards>
					<div className='Buff-Debuff'>
						<div className='jobSection'>
							<div className='jobName'>
								<img
									src={
										'https://images.roprime-simulator.com/classicon/ARCH_BISHOP.bmp'
									}
									alt=''
								/>
								Arch Bishop
							</div>
							<div className='bufflist'>
								{partyBuffList_AB.map((currentbuff) =>
									addNewBuff(
										currentbuff,
										'partyBuff',
										handleBuffChange,
									),
								)}
							</div>
						</div>
						<div className='jobSection'>
							<div className='jobName'>
								<img
									src={
										'https://images.roprime-simulator.com/classicon/MINSTREL.bmp'
									}
									alt=''
								/>
								<img
									src={
										'https://images.roprime-simulator.com/classicon/WANDERER.bmp'
									}
									alt=''
								/>
								Minstrel and Wanderer
							</div>
							<div className='bufflist'>
								{partyBuffList_MIWA.map((currentbuff) =>
									addNewBuff(
										currentbuff,
										'partyBuff',
										handleBuffChange,
									),
								)}
							</div>
						</div>
					</div>
				</Cards> */}
				<Cards Name={'Battle tab'}>
					<div className='Results'>
						<div className='Monster'>
							<MonsterWindow onMonsterSelect={createMonster} />
						</div>
						<div>
							<div className='div'>
								<Select
									ref={skillRef}
									menuPosition='fixed'
									styles={customStyles}
									className='skill'
									onChange={(event) => {
										// console.log('event', event)
										setCurrentSkill(event.value)
									}}
									options={options}
								/>
								<Select
									ref={skillLvRef}
									menuPosition='fixed'
									defaultValue={{
										value: 1,
										label: 1,
										key: 'skLv' + 1,
									}}
									styles={customStyles}
									className='skillLV'
									onChange={(event) => {
										setCurrentSkillLv(Number(event.value))
									}}
									options={optionsSkillLv}
								/>
							</div>

							<div>
								<div className='ActiveSkill'>
									<div className='SkillImgAndLevel'>
										<img
											src={
												'https://images.roprime-simulator.com/item/' +
												currentSkill.toLowerCase() +
												'.bmp'
											}
											alt={currentSkill}
										></img>
									</div>
									<div className='SkillRatio'>
										skill ratio : <br />
										{getSkillRatio(
											{ miscflag: 0 },
											currentSkill,
											currentSkillLv,
											currentPlayer,
											monster,
										)}
										%Atk
									</div>
								</div>
							</div>
							{skillDamages.map((skillDamage, index) => (
								<div key={'dmg' + index}>
									{tempLabel[index]} =
									{' ' +
										(skillOption > 0
											? skillDamage * skillOption
											: Math.floor(
													skillDamage / -skillOption,
												) * -skillOption)}
									<br />
									{skillOption !== 1
										? skillOption > 0
											? ' (' +
												skillOption +
												' x ' +
												skillDamage +
												')'
											: ' (' +
												-skillOption +
												' x ' +
												Math.floor(
													skillDamage / -skillOption,
												) +
												')'
										: null}
									{/* // (skillOption === 1
										// 	? skillDamage
										// 	: skillOption > 0
										// 		? skillDamage * skillOption +
										// 			' (' +
										// 			skillOption +
										// 			' x ' +
										// 			skillDamage +
										// 			')'
										// 		: Math.floor(
										// 				skillDamage /
										// 					-skillOption,
										// 			) *
										// 				-skillOption +
										// 			' (' +
										// 			-skillOption +
										// 			' x ' +
										// 			Math.floor(
										// 				skillDamage /
										// 					-skillOption,
										// 			) +
										// 			')')
													// } */}
								</div>
							))}
						</div>
					</div>
				</Cards>
			</div>
		</div>
	)
}

export default BattleTab
function getSkillList(SkillType, currentJob) {
	let skillList = []

	SkillActivePassive[jobID.getFirstClassName(currentJob)][SkillType].forEach(
		(sk) => skillList.push(sk),
	)

	if (jobID.isSecondJob(currentJob)) {
		SkillActivePassive[jobID.getSecondClassName(currentJob)][
			SkillType
		].forEach((sk) => skillList.push(sk))
	}

	if (jobID.isSecondJob(currentJob) && jobID.isRebirth(currentJob)) {
		SkillActivePassive[jobID.getSecondRebirthClassName(currentJob)][
			SkillType
		].forEach((sk) => skillList.push(sk))
	}

	if (jobID.isThirdJob(currentJob)) {
		SkillActivePassive[jobID.getThirdClassName(currentJob)][
			SkillType
		].forEach((sk) => skillList.push(sk))
	}
	return skillList
}
// function addNewBuff(currentbuff, keyname, handleBuffChange) {
// 	return (
// 		<div className='Skill' key={keyname + currentbuff}>
// 			<div className='SkillIconAndName'>
// 				<img
// 					src={
// 						'https://images.roprime-simulator.com/item/' +
// 						currentbuff.toLowerCase() +
// 						'.bmp'
// 					}
// 					alt=''
// 				/>
// 				<div>
// 					{
// 						SkillOption.find((skill) => skill.Name === currentbuff)
// 							.Description
// 					}
// 				</div>
// 			</div>
// 			<div className='select'>
// 				{createSelect(
// 					Object.entries(skillInfoList).find(
// 						(skill) => skill[1]['1'] === currentbuff,
// 					)[1],
// 					handleBuffChange,
// 				)}
// 			</div>
// 		</div>
// 	)
// }
// function addOptions(amount) {
// 	let options = []
// 	for (let i = 0; i <= amount; i++) options.push(i)

// 	return options
// }

// function createSelect(skill_, handleBuffChange) {
// 	return (
// 		<select onChange={(event) => handleBuffChange(event, skill_['1'])}>
// 			{addOptions(skill_?.MaxLv).map((buffLv) => (
// 				<option key={skill_['1'] + buffLv}>{buffLv}</option>
// 			))}
// 		</select>
// 	)
// }
function initBuffs(NewBuffsList_, CurrentBuffsList_) {
	NewBuffsList_.forEach((currentbuff) => {
		CurrentBuffsList_.push({
			name: currentbuff,
			level: 0,
		})
	})
}

function convertPlayerToEntity(player, substats, skills, bonuses) {
	let entityPlayer = new Player(
		player.BaseLevel,
		player.JobLevel,
		skills,
		substats,
		player.Stats,
		bonuses,
		player.Inventory,
	)
	// 	constructor(blv, jlv, skills, subStats, stats, bonuses, inventory) {
	// 	this.Stats = {
	// 	str: Stats.baseSTR ? Stats.baseSTR : 1,
	// 	agi: Stats.baseAGI ? Stats.baseAGI : 1,
	// 	vit: Stats.baseVIT ? Stats.baseVIT : 1,
	// 	int: Stats.baseINT ? Stats.baseINT : 1,
	// 	dex: Stats.baseDEX ? Stats.baseDEX : 1,
	// 	luk: Stats.baseLUK ? Stats.baseLUK : 1,
	// }
	// this.Job = job ? job : 0
	// this.BaseLevel = Blv ? Blv : 1
	// this.JobLevel = Jlv ? Jlv : 1
	// this.Inventory = Inventory
	return entityPlayer
}

// 		{
// 			MaxHP: maxHP,
// 			MaxSP: maxSP,
// 			DEF: Def,
// 			SoftDEF: softDef,
// 			MDEF: Mdef,
// 			SoftMDEF: softMdef,
// 			Hit: hit,
// 			Flee: flee,
// 		},
// 		{ Str: STR, Agi: AGI, Vit: VIT, Int: INT, Dex: DEX, Luk: LUK },
// 		bonuses,
